<template>
  <div class="order-details">
    <navbar left-text show-home title="订单详情" />
    <div class="order-details-wrapper" v-if="orderDetails.trade_id">
      <!-- 订单状态展示 -->
      <div class="header">
        <!-- 待支付状态 -->
        <div
          class="header-public header-pay"
          v-if="orderDetails.status == 0 || orderDetails.status == 1"
        >
          <div class="header-status">
            <span>{{ orderDetails.status_remark }}</span>
            <span>
              请尽快支付哦～
              <count-down
                :endTime="orderDetails.exp_at"
                :startTime="countDown.startTime"
                @endCallback="countDownEnd"
                endText="订单已失效"
              ></count-down>
            </span>
          </div>
          <div class="header-icon"></div>
        </div>

        <!-- 订单超时, 取消 -->
        <div
          class="header-public header-pay"
          v-if="orderDetails.status == 99 || orderDetails.status == -1"
        >
          <div class="header-status">
            <span>{{ orderDetails.status_remark }}</span>
            <!-- <span>请尽快支付哦～ 29 : 58</span> -->
          </div>
          <div class="header-icon"></div>
        </div>

        <!-- 支付成功,正在下单 -->
        <div
          class="header-public header-ordering"
          v-if="orderDetails.status === 101 || orderDetails.status === 100"
        >
          <div class="header-status">
            <span>{{ orderDetails.status_remark }}</span>
            <span>平台正在为您下单…</span>
          </div>
          <div class="header-icon"></div>
        </div>
        <!-- 下单成功 待收货 -->
        <div
          class="header-public header-no-received"
          v-if="orderDetails.status >= 200 && orderDetails.status < 400"
        >
          <div class="header-status">
            <span>{{ orderDetails.status_remark }}</span>
            <span>下单成功！请耐心等待收货吧</span>
          </div>
          <div class="header-icon"></div>
        </div>

        <!-- 完成订单 -->
        <div
          class="header-public header-finished"
          v-if="orderDetails.status === 400"
        >
          <div class="header-status">
            <span>{{ orderDetails.status_remark }}</span>
          </div>
          <div class="header-icon"></div>
        </div>

        <!-- 下单失败, 系统退单 -->
        <div
          class="header-public header-finished"
          v-if="orderDetails.status === 502"
        >
          <div class="header-status">
            <span>{{ orderDetails.status_remark }}</span>
          </div>
          <div class="header-icon"></div>
        </div>
      </div>

      <!-- 订单地址信息 -->
      <div class="user-address-list" v-if="orderDetails.receiver">
        <div class="title van-hairline--bottom">
          <span>本订单包含{{ orderDetails.receiver.length }}个地址</span>
          <button
            @click="checkLogistics(orderDetails.trade_id)"
            class="check-logistics"
            v-show="orderDetails.status >= 300 && orderDetails.status <= 400"
          >
            查看物流
          </button>
        </div>
        <div class="platform-address van-hairline--bottom">
          <div class="address-intro">
            {{ userAddress(orderDetails.receiver[0].receiver) }}
          </div>
          <div class="user-info">
            <span>{{ orderDetails.receiver[0].receiver.name }}</span>
            <span>{{ orderDetails.receiver[0].receiver.mobile }}</span>
          </div>
          <div class="platform-name">
            {{ orderDetails.receiver[0].platform.brand }}
          </div>
        </div>
        <div class="user-address-wrapper">
          <transition name="van-slide-down">
            <ul v-show="showAddress">
              <li
                :key="index"
                class="platform-address van-hairline--bottom"
                v-for="({ receiver, platform }, index) in orderDetails.receiver"
                v-show="index >= 1"
              >
                <div class="address-intro">{{ userAddress(receiver) }}</div>
                <div class="user-info">
                  <span>{{ receiver.name }}</span>
                  <span>{{ receiver.mobile }}</span>
                </div>
                <div class="platform-name">{{ platform.brand }}</div>
              </li>
            </ul>
          </transition>
        </div>
        <div
          class="functional-button"
          v-show="orderDetails.receiver.length > 1"
        >
          <button @click="toggleAddress" class="open-list">
            {{ toggleText }}
          </button>
        </div>
      </div>

      <!-- 订单sku 列表 -->
      <div class="order-sku-lists">
        <sku-list :sku-list="orderDetails.sku_list" :orderDetails='orderDetails'></sku-list>
      </div>

      <!-- 订单价格详情 -->
      <div class="order-price-intro">
        <div class="price-item">
          <span>商品金额</span>
          <span>¥{{ orderDetails.market_price }}</span>
        </div>
        <div class="price-item">
          <span>运费</span>
          <span>+ ¥{{ orderDetails.count_exp_fee }}</span>
        </div>
        <template v-if="orderDetails.deduct.length">
          <div
            :key="index"
            class="price-item"
            v-for="(discountItem, index) in orderDetails.deduct"
          >
            <span>{{ discountItem.pay_type }}</span>
            <span class="member-price-color">- ¥{{ discountItem.number }}</span>
          </div>
        </template>
        <div class="price-item" v-show="orderDetails.sa * 1 > 0">
          <span>福利金抵扣</span>
          <span class="member-price-color">- ¥{{ orderDetails.sa }}</span>
        </div>
        <div class="price-item" v-show="orderDetails.sb * 1 > 0">
          <span>爱心币抵扣</span>
          <span class="member-price-color">- ¥{{ orderDetails.sb }}</span>
        </div>
        <div class="price-item" v-show="orderDetails.se * 1 > 0">
          <span>体验金抵扣</span>
          <span class="member-price-color">- ¥{{ orderDetails.se }}</span>
        </div>
        <div
          class="price-item"
          v-show="
            discountsPrice(
              orderDetails.market_price,
              orderDetails.count_selling_price
            )
          "
        >
          <span>会员优惠</span>
          <span class="member-price-color"
            >- ¥{{
              discountsPrice(
                orderDetails.market_price,
                orderDetails.count_selling_price
              )
            }}</span
          >
        </div>
        <div class="price-item real-pay">
          <span>实付金额</span>
          <span>¥{{ orderDetails.count_real_pay }}</span>
        </div>
        <div class="price-item rebate-price" v-show="orderDetails.status < 502">
          <span>共返福利金</span>
          <span>{{ orderDetails.count_rebate }}</span>
        </div>
        <div class="price-item" v-show="orderDetails.refund * 1">
          <span>订单退款</span>
          <span class="member-price-color">- ¥{{ orderDetails.refund }}</span>
        </div>
        <div
          class="order-tips"
          v-show="orderDetails.status < 400 && orderDetails.count_rebate * 1"
        >
          （确认收货后福利金到账）
        </div>
      </div>

      <!-- 订单信息介绍 -->
      <div class="order-info-intro">
        <div class="title">订单信息</div>
        <div class="order-info-desc">
          <div class="order-num">订单编号：{{ orderDetails.trade_id }}</div>
          <div class="order-time">创建时间：{{ orderDetails.create_at }}</div>
        </div>
        <div class="order-service">联系客服：400-6687017</div>
        <div class="online-service">
          <online-service />
        </div>
      </div>
    </div>
    <!-- 底部导航 仅未支付状态 -->
    <div
      class="order-footer"
      v-show="orderDetails.status === 0 || orderDetails.status === 1"
    >
      <button
        @click="cancelOrder(orderDetails.trade_id)"
        class="cancel-order"
        v-show="orderDetails.status === 0"
      >
        取消订单
      </button>
      <button @click="payNow(orderDetails.trade_id)" class="pay-now">
        立即支付
      </button>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
import CountDown from '../components/CountDown'
import SkuList from '../components/OrderDetailsSkuList'
import OnlineService from '../components/OnlineService'
import Big from 'big.js'
const init = new Big(0)
let flag = false
export default {
  name: 'orderDetails',
  components: {
    Navbar,
    SkuList,
    CountDown,
    OnlineService
  },
  data () {
    return {
      showAddress: false,
      orderDetails: {},
      countDown: {
        loseEfficacy: false,
        startTime: new Date().getTime()
      }
    }
  },
  computed: {
    toggleText () {
      return this.showAddress ? '收起' : '展开'
    },
    discountsPrice (marketPrice, realPrice) {
      return (marketPrice, realPrice) => {
        let disPrice = init.plus(marketPrice).minus(realPrice)
        if (disPrice > 0) {
          return disPrice.toFixed(2)
        } else {
          return false
        }
      }
    },
    userAddress (address) {
      return address => {
        const townName = address.town_name !== '0' ? address.town_name : ''
        return (
          address.province_name +
          address.city_name +
          address.district_name +
          townName +
          address.address_detail
        )
      }
    }
  },
  created () {
    this.getOrderDetails()
  },
  methods: {
    onlineService () {
      location.href = process.env.VUE_APP_ONLINEA_SERVICE
    },
    async getOrderDetails () {
      this.$toast.loading('加载中...')
      const res = await this.$axios.get(
        `api/order/detail/${this.$route.query.orderid}`
      )
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.$toast.clear()
          this.orderDetails = data
        } else if (code === 9006) {
        } else {
          this.$toast(msg)
        }
      }
    },
    toggleAddress () {
      this.showAddress = !this.showAddress
    },
    countDownEnd () {
      this.orderDetails.status = 99
      this.orderDetails.status_remark = '订单已过期'
    },
    checkLogistics (orderid) {
      this.$router.push({ name: 'logisticsInfo', query: { orderid } })
    },
    async cancelOrder (trade) {
      const res = await this.$axios.post('/api/order/cancel', { trade })
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast.success('取消成功')
          this.updateView()
        } else {
          this.$toast(msg)
        }
      }
    },
    updateView () {
      this.orderDetails.status = -1
      this.orderDetails.status_remark = '已取消'
    },
    /**
     *  支付
     * @param{String} id 订单id
     */
    async payNow (id) {
      if (flag) {
        return
      }
      flag = true
      const res = await this.$axios.post('/api/pay/order', { id })
      if (res.status === 200) {
        const { code, data, msg } = res.data
        flag = false
        if (code === 0) {
          location.href = data.redirect
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-details {
  padding-bottom: 1.5rem;
}
.goHome {
  width: 0.58rem;
  height: 0.58rem;
  background: url('../assets/img/share.png') center no-repeat;
  background-size: 100%;
}
.order-details-wrapper {
  .header-public {
    display: flex;
    justify-content: space-between;
    height: 2.05rem;
    color: #fff;
    .header-status {
      padding-top: 0.33rem;
      padding-left: 0.57rem;
      .flex-column;
      span:nth-child(1) {
        font-size: @fz32;
        font-weight: bold;
      }
      span:nth-child(2) {
        font-size: @fz24;
        padding-top: 0.1rem;
      }
    }
    .header-icon {
      margin-right: 0.78rem;
    }
  }
  .header-pay {
    background: linear-gradient(
      217deg,
      rgba(255, 102, 102, 1) 0%,
      rgba(221, 71, 71, 1) 100%,
      rgba(221, 71, 71, 1) 100%
    );
    .header-icon {
      width: 1.02rem;
      height: 1.07rem;
      background: url('../assets/img/order-pay-icon.png') center no-repeat;
      background-size: 100%;
      margin-right: 1.04rem;
      margin-top: 0.28rem;
    }
  }
  .header-ordering {
    background-color: #4a90e2;
    .header-icon {
      width: 0.99rem;
      height: 0.99rem;
      background: url('../assets/img/order-bag-icon.png') center no-repeat;
      background-size: 100%;
      margin-top: 0.37rem;
    }
  }
  .header-no-received {
    background-color: #4a90e2;
    .header-icon {
      width: 1.17rem;
      height: 0.99rem;
      background: url('../assets/img/order-car-icon.png') center no-repeat;
      background-size: 100%;
      margin-top: 0.32rem;
    }
  }
  .header-finished {
    background-color: #16a085;
    .header-icon {
      width: 1.05rem;
      height: 1.05rem;
      background: url('../assets/img/order-finish-icon.png') center no-repeat;
      background-size: 100%;
      margin-top: 0.37rem;
    }
  }
  .user-address-list {
    margin: -0.4rem 0.2rem 0;
    font-size: @fz28;
    color: @base;
    border-radius: 0.12rem;
    background-color: #fff;
    .title {
      padding: 0 0.27rem;
      height: 0.78rem;
      .flex-between;
      .check-logistics {
        width: 1.69rem;
        height: 0.58rem;
        color: #1a65dd;
        font-size: @fz24;
        background-color: #c2defe;
        border-radius: 30px;
      }
    }
    .platform-address {
      padding: 0.25rem 0.3rem;
      .address-intro {
        font-size: @fz26;
      }
      .user-info {
        font-size: @fz26;
        color: @c80;
        padding: 0.12rem 0 0.2rem;
        span:nth-child(2) {
          padding-left: 0.6rem;
        }
      }
      .platform-name {
        color: #cbcbcb;
      }
    }
    .functional-button {
      height: 0.62rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      button {
        padding-right: 0.33rem;
        color: #0076ff;
      }
    }
  }
  .user-address-wrapper {
    overflow: hidden;
  }
  .order-sku-lists {
    margin: 0.3rem 0.2rem;
    background-color: #fff;
    border-radius: 0.08rem;
  }
  .order-price-intro {
    margin: 0.3rem 0.2rem 0;
    padding: 0.23rem 0.2rem 0.33rem;
    background-color: #fff;
    font-size: @fz28;
    color: @base;
    .price-item {
      .flex-between;
      padding-bottom: 0.2rem;
      &:nth-child(2) {
        span:nth-child(2) {
          color: @price;
        }
      }
      .member-price-color {
        color: #2ecc71;
      }
    }
    .real-pay {
      border-top: 0.5px dashed #979797;
      font-weight: bold;
      padding-top: 0.15rem;
      padding-bottom: 0.2rem;
      span:nth-child(2) {
        color: @price;
      }
    }
    .rebate-price {
      // padding-top: 0.2rem;
      // border-top: 0.5px dashed #979797;
      // color: #FF9600;
    }
    .order-tips {
      text-align: right;
    }
  }
  .order-info-intro {
    margin: 0.3rem 0.2rem 1.8rem;
    background-color: #fff;
    font-size: @fz24;
    color: @base;
    border-radius: 0.08rem;
    .title {
      padding: 0.27rem 0 0.16rem;
      font-size: @fz28;
      font-weight: bold;
      padding-left: 0.4rem;
    }
    .order-info-desc {
      padding-left: 0.4rem;
      border-bottom: 0.5px solid #dadada;
    }
    .order-num {
      padding-right: 0.4rem;
      word-break: break-all;
    }
    .order-time {
      padding: 0.27rem 0;
    }
    .order-service {
      height: 0.84rem;
      padding-left: 0.4rem;
      display: flex;
      align-items: center;
    }
    .online-service {
      padding: 0 0 0.3rem 0.3rem;
    }
  }
}
.order-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #fff;
  button {
    width: 2rem;
    height: 0.68rem;
    font-size: @fz28;
    border-radius: 30px;
    margin-right: 0.34rem;
  }
  .cancel-order {
    border: 0.5px solid #b0b0b0;
    box-sizing: border-box;
    color: @c80;
  }
  .pay-now {
    background-color: #ff3824;
    color: #fff;
  }
}
</style>
